module.exports = __webpack_public_path__ + "img/tip1-small.b255b9b3.png";